import React from 'react';

import { isJssField } from 'core/utils/sitecore-utils';
import IProps from 'pods/forms/components/formFieldProps.d';
import CtrlHolder from 'pods/forms/components/structural/CtrlHolder';

import * as S from './TextArea.style';

export const RawTextArea = (props: any) => <S.TextArea {...props} />;

const TextArea = ({
	config,
	computed,
	htmlId,
	path,
	handleChangeFast,
	handleBlurFast,
	handleKeyPressFast,
	value,
	getDisplayError,
	renderTextNode,
	ctrlHolderProps,
}: IProps) => {
	const { data = {} } = config ?? {};
	const {
		inputAttrs = {},
		labelHelpText,
		placeholder,
		autoGrow,
		showRemainingCharacters = {},
	} = data;

	const label = isJssField(data.label)
		? data.label
		: renderTextNode && renderTextNode(data.label, 'span');
	const helpText = isJssField(labelHelpText)
		? labelHelpText
		: renderTextNode && renderTextNode(labelHelpText, 'span');
	const tooltip = renderTextNode && renderTextNode(data.tooltip);
	const errorMsg = getDisplayError && getDisplayError();
	const { required, disabled } = computed;

	const _ctrlHolderProps = {
		htmlId,
		label,
		helpText,
		errorMsg,
		required,
		value,
		...(data.tooltip && { tooltip }),
		...ctrlHolderProps,
	};

	const hasError = !!errorMsg;
	const hasValue = !!value;
	const hasHelpText = !!helpText;
	const hasAutoGrow = !!autoGrow;
	const hasShowRemainingCharacters = !!showRemainingCharacters?.max;

	const handleAutoGrow = (target: HTMLElement) => {
		const scrollHeight = target.scrollHeight;
		if (scrollHeight > target.clientHeight) {
			target.style.height = `${scrollHeight}px`;
		}
	};

	const remainingCharacters = () => {
		const { max, messageTemplate } = showRemainingCharacters;
		const n = (max - value.length).toLocaleString();

		return (
			(messageTemplate && messageTemplate.replace('${n}', n)) ||
			`${n} characters remaining`
		);
	};

	return (
		<CtrlHolder {..._ctrlHolderProps}>
			<RawTextArea
				id={htmlId}
				name={path}
				value={value || ''}
				onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
					handleChangeFast(e.target.value);
					hasAutoGrow && handleAutoGrow(e.target);
				}}
				onBlur={() => handleBlurFast()}
				onKeyPress={handleKeyPressFast}
				required={required}
				disabled={disabled}
				aria-describedby={hasHelpText ? `${htmlId}-helpText` : undefined}
				{...{ required, disabled, hasError, hasValue, placeholder }}
				{...inputAttrs}
			/>
			{hasShowRemainingCharacters && (
				<S.RemainingCharacters>{remainingCharacters()}</S.RemainingCharacters>
			)}
		</CtrlHolder>
	);
};

export default TextArea;
